import React from 'react';
import { SuggestedModalState } from './suggestedModalState/SuggestedModalState';
import { EditForm } from './components/EditForm';

interface IProps {
	onFailureEvent?: () => void;
	onCloseModal: () => void;
	onShowError: () => void;
}

export const SuggestedModal: React.FC<IProps> = ({ onFailureEvent, onCloseModal, onShowError }) => {
	return (
		<SuggestedModalState>
			<EditForm onCloseModal={onCloseModal} onFailureEvent={onFailureEvent} onShowError={onShowError} />
		</SuggestedModalState>
	);
};
